import axios from 'axios';
import { debug } from 'debug';
import { getReasonPhrase, StatusCodes } from 'http-status-codes';
import { HTTPRequestError } from '../../models/http';
import { OPERATION_ROUTE } from '../configs/operation-api';
import { SocialGetUserDataResponseInterface } from '../models/operation-get-user-data';

export const getUserData =
	async (): Promise<SocialGetUserDataResponseInterface> => {
		const response = await axios.get<SocialGetUserDataResponseInterface>(
			OPERATION_ROUTE.GET_USER_DATA,
		);

		if (response.status !== StatusCodes.OK) {
			debug(`Error: ${response.status}`);
			throw new HTTPRequestError(getReasonPhrase(response.status));
		}

		return response.data;
	};
